<template>
  <div id="table-deposit" class="table__container">
    <div class="transaction__filter--container bg-white py-2">
      <b-row class="search__export align-items-center">
        <b-col cols="10">
          <div class="d-flex pl-2">
            <b-img
              class="filter-image"
              :class="filter.sort_type == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')"
              alt="Icon-order-list-down"
              role="button"
              @click="
                filter.sort_type == 'asc'
                  ? (filter.sort_type = 'desc')
                  : (filter.sort_type = 'asc')
              "
            />
            <div class="search__input w-100 pl-2 pr-0 mr-0">
              <b-input-group>
                <b-form-input
                  v-model="filter.search"
                  placeholder="Cari Nama Pemasok"
                />
                <b-input-group-append is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-col>
        <b-col cols="2" class="px-0">
          <div>
            <b-button
              class="py-1 border-8 w-100"
              @click="$bvModal.show('modal-purchase')"
            >
              Tambah Pemesanan
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      v-if="isLoading == true"
      class="d-flex justify-content-center mb-1 mt-5"
    >
      <b-spinner label="Loading..." />
    </div>

    <vue-good-table
      v-else
      max-height="80vh"
      :columns="columns"
      :rows="rows.data"
      :fixed-header="false"
      :sort-options="{
        enabled: false,
      }"
      :pagination-options="{
        enabled: false,
      }"
    >
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'action'" />
        <span v-else>
          <span>
            {{ props.column.label }}
          </span>
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->

        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown id="dropdown-dropleft" class="d-flex" right>
              <template #button-content class="btn-white text-center">
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle"
                />
              </template>
              <b-dropdown-item @click="detailItem(props.row)">
                <span class="pr-5"> Detail Data </span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

    <div
      v-if="rows && isLoading == false"
      class="d-flex justify-content-between align-items-center flex-wrap bg-white border"
      style="padding: 0.8rem"
    >
      <div class="d-flex align-items-center">
        <b-form-select
          v-model="filter.per_page"
          :options="['10', '15', '20']"
          class="mx-1"
        />
        <span class="text-nowrap">
          Tampilkan
          {{
            rows.total > 0 ? filter.per_page * (rows.current_page - 1) + 1 : 0
          }}
          ke
          {{
            rows.total > 0
              ? Math.min(filter.per_page * rows.current_page, rows.total)
              : 0
          }}
          dari {{ rows.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination
              class="mb-0"
              :data="rows"
              :limit="4"
              align="right"
              @pagination-change-page="getData"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <ModalPurchase
      :results="resultDetail"
      :editId="editId"
      :list-merchant="listMerchant"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from "lodash";
import { errorNotification } from "@/auth/utils";
import {
  BPagination,
  BFormSelect,
  VBToggle,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";

import ModalPurchase from "@/components/Purchase/Modal/ModalPurchase.vue";

import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormSelect,
    ModalPurchase,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
  },
  setup() {
    return {
      errorNotification,
    };
  },
  directives: {
    "b-toggle": VBToggle,
  },
  data() {
    return {
      editId: "",
      isLoading: false,
      columns: [
        {
          label: "Tanggal",
          field: "booking_date",
        },
        {
          label: "No. Pemesanan",
          field: "po_booking_number",
        },
        {
          label: "Pemasok",
          field: "target_merchat_name",
        },
        {
          label: "Metode Bayar",
          field: "payment_type",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Jenis Pemesanan",
          field: "booking_type",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: {},
      filter: {
        search: "",
        per_page: 10,
        sort_type: "desc",
      },
      resultDetail: {},
      listMerchant: [],
      formPayload: {
        po_application_id: null,
        booking_date: "",
        items: [
          {
            product_id: "",
            qty: 0,
            is_need_negotiation: 0,
            price: 0,
            discounts: 0,
          },
        ],
      },
    };
  },
  watch: {
    filter: {
      handler: _.debounce(function () {
        this.getData();
      }, 300),
      deep: true,
    },
  },
  created() {
    this.getData();
    this.getPengajuan();
  },
  methods: {
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        po_application_id: null,
        booking_date: "",
        items: [
          {
            product_id: "",
            qty: 0,
            is_need_negotiation: 0,
            price: 0,
            discounts: 0,
          },
        ],
      };
      this.validations = "";
    },
    detailItem(item) {
      this.cleanUpForm();
      this.editId = item.uuid;
      this.$store.commit(
        "cabang/setFormPayload",
        (this.formPayload = {
          name: item.name,
          date: item.date,
          petty_cash_permissions: item.petty_cash_permissions,
        })
      );
      this.$bvModal.show("modal-purchase");
    },
    preparePayload() {
      const { ...formPayloadWithoutPettyCashSeperate } = this.formPayload;

      const form = new FormData();

      for (const key in formPayloadWithoutPettyCashSeperate) {
        if (formPayloadWithoutPettyCashSeperate.hasOwnProperty(key)) {
          if (key === "operational_hours") {
            formPayloadWithoutPettyCashSeperate[key].forEach((hour, index) => {
              Object.keys(hour).forEach((hourKey) => {
                const fieldName = `operational_hours[${index}][${hourKey}]`;

                if (hourKey === "is_holiday") {
                  form.append(fieldName, hour[hourKey] ? "1" : "0");
                } else {
                  form.append(fieldName, hour[hourKey]);
                }
              });
            });
          } else if (key === "petty_cash_permissions") {
            formPayloadWithoutPettyCashSeperate[key].forEach((cash, index) => {
              Object.keys(cash).forEach((key) => {
                if (key !== "operator_name") {
                  form.append(
                    "petty_cash_permissions" + "[" + index + "]",
                    cash[key]
                  );
                }
              });
            });
          }
        }
      }

      return form;
    },
    createItem() {
      this.$swal({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin melakukan pemesanan?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {

          const form = this.preparePayload();
          this.isLoading = true;
          this.$store
            .dispatch("pemesanan/postData", {
              query: "",
              payload: form,
            })
            .then(() => {
              this.getData();
              successNotification(this, "Success", "Berhasil melakukan pemesanan");
              this.cleanUpForm();
              this.$bvModal.hide("modal-purchase");
              this.isLoading = false;
            })
            .catch((error) => {
              this.messages = error.response.data.meta.messages;
              this.isLoading = false;
            });
        }
      });
    },
    updateItem() {
      this.$swal({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin mengubah data Cabang ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.formPayload.address_latitude =
            this.selectedLocation.position.lat;
          this.formPayload.address_longitude =
            this.selectedLocation.position.lng;

          const form = this.preparePayload();
          this.isLoading = true;
          form.append("_method", "PATCH");

          this.$store
            .dispatch("cabang/postData", {
              query: `${this.editId}`,
              payload: form,
            })
            .then(() => {
              this.getData();
              successNotification(this, "Success", "Cabang berhasil diubah!");
              this.cleanUpForm();
              this.isLoading = false;
              this.$bvModal.hide("modal-cabang");
              window.location.reload();
            })
            .catch((error) => {
              this.messages = error.response.data.meta.messages;
              this.isLoading = false;
            });
        }
      });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      queryParams.only_have_balance = 1;
      this.$store
        .dispatch("pemesanan/getData", {
          params: queryParams,
        })
        .then((result) => {
          this.rows = result.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
          this.isLoading = false;
          console.log(err);
        });
    },
    async getPengajuan() {
      this.$store
        .dispatch("pengajuan/getData", {
          uuid: "",
          params: "",
        })
        .then((result) => {
          this.listMerchant = result.data.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          if (err.response.data.meta.messages) {
            errorNotification(this, "Oops!", err.response.data.meta.messages);
          }
          this.isLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";

#table-deposit {
  .vgt-responsive {
    height: calc(100vh - 235px) !important;
    background-color: #fff;
  }
}
</style>
